module.exports = "<div class=\"page-default\">\n  <h1>Oeps!</h1>\n  <p>Zorg ervoor dat u een correct geformateerde url invoert.</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/default/default.html
// module id = 665
// module chunks = 0